import { CheckboxCell } from './CheckboxCell';
import { ChipsCell } from './ChipsCell';
import { DatetimeCell } from './DatetimeCell';
import { FileSystemCell } from './FileSystemCell';
import { LinkCell } from './LinkCell';
import { LoadingCell } from './LoadingCell';
import { MenuCell } from './MenuCell';
import { NumberCell } from './NumberCell';
import { RadioCell } from './RadioCell';
import { StatusTextCell } from './StatusTextCell';
import { StepsCell } from './StepsCell';
import { TextCell } from './TextCell';
import { UserCell } from './UserCell';
import { UserDatetimeCell } from './UserDatetimeCell';
import { UsersCell } from './UsersCell';

export const renderers = {
  checkbox: CheckboxCell,
  chips: ChipsCell,
  filesystem: FileSystemCell,
  datetime: DatetimeCell,
  link: LinkCell,
  loading: LoadingCell,
  number: NumberCell,
  menu: MenuCell,
  radio: RadioCell,
  statusText: StatusTextCell,
  steps: StepsCell,
  text: TextCell,
  user: UserCell,
  userDatetime: UserDatetimeCell,
  users: UsersCell,
};
